import { Box } from "@mui/material";

type NavbarProps = {
    current: JSX.Element;
    mobile?: JSX.Element;
}

export const NavbarContainer = ({ current, mobile }: NavbarProps) => {
    return (
        <Box>
            <Box
                sx={{
                    "@media(max-width: 768px)": {
                        display: "none",
                    },
                }}
            >
                {current}
            </Box>
            {!!mobile && 
                <Box
                    sx={{
                        display: "none",
                        "@media (max-width: 768px)": {
                            display: "block",
                        },
                    }}
                >
                    {mobile}
                </Box>
            }
        </Box>
    )
}